import { put } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';

import {
	connectGong,
	connectIntercom,
	connectOutreach,
	connectZendesk,
	disconnectApplication,
	getApplications,
	sendCodeOutreach,
} from './service';
import {
	getApplicationsSuccessAction,
	getApplicationsFailureAction,
	connectOutreachFailureAction,
	connectOutreachSuccessAction,
	disconnectAppSuccessAction,
	disconnectAppFailureAction,
	connectIntercomFailureAction,
	connectIntercomSuccessAction,
	connectGongFailureAction,
	connectGongSuccessAction,
	connectZendeskSuccessAction,
	connectZendeskFailureAction,
} from './action';

export function* getApplicationsSaga() {
	try {
		const { data }: AxiosResponse = yield getApplications();
		yield put(getApplicationsSuccessAction(data.data));
	} catch (e) {
		yield put(getApplicationsFailureAction(e as Error));
	}
}

export function* disconnectApplicationSaga(action: any) {
	const { appId } = action.payload;
	try {
		yield disconnectApplication(appId);
		yield put(disconnectAppSuccessAction(appId));
	} catch (e) {
		yield put(disconnectAppFailureAction(e as Error));
	}
}

export function* connectOutreachSaga(action: any) {
	try {
		const { data }: AxiosResponse = yield connectOutreach(action.payload);
		const windowReference = window.open();
		windowReference!.location = data.data;
	} catch (e) {
		yield put(connectOutreachFailureAction(e as Error));
	}
}

export function* connectIntercomSaga(action: any) {
	try {
		const { data }: AxiosResponse = yield connectIntercom(action.payload);
		const windowReference = window.open();
		windowReference!.location = data.data;
		yield put(connectIntercomSuccessAction());
	} catch (e) {
		yield put(connectIntercomFailureAction(e as Error));
	}
}

export function* connectGongSaga(action: any) {
	try {
		const { data }: AxiosResponse = yield connectGong(action.payload);
		const windowReference = window.open();
		windowReference!.location = data.data;
		yield put(connectGongSuccessAction());
	} catch (e) {
		yield put(connectGongFailureAction(e as Error));
	}
}

export function* connectZendeskSaga(action: any) {
	try {
		const { data }: AxiosResponse = yield connectZendesk(action.payload);
		const windowReference = window.open();
		windowReference!.location = data.data;
		yield put(connectZendeskSuccessAction());
	} catch (e) {
		yield put(connectZendeskFailureAction(e as Error));
	}
}

export function* sendCodeOutreachSaga(action: any) {
	try {
		yield sendCodeOutreach(action.payload);
		yield put(connectOutreachSuccessAction());
	} catch (e) {
		yield put(connectOutreachFailureAction(e as Error));
	}
}
